<template>
  <div id="app">
    <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive> -->
    <router-view v-if="!$route.meta.keepAlive"></router-view>


  </div>
</template>

<script>
  import Vue from 'vue';
  export default {
    name: 'App',
    created() {
      AppEvent = new Vue();
    }
  };
</script>

<style>
  @charset "utf-8";
  *{
    -webkit-overflow-scrolling: touch;
  }

  /*公共样式*/
  body,
  div,
  ul,
  li,
  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  form,
  dt,
  dd,
  input,
  textarea {
    margin: 0px;
    padding: 0px;
    font-size: 16px;
    font-weight: inherit;

  }

  a {
    text-decoration: none;
  }

  ul {
    list-style-type: none;
  }

  img {
    border: 0px;
    max-width: 100%;
    height: auto;
    object-fit: cover;
  }

  /*清除浮动，自动高度*/
  .clr {}

  /*元素之后*/
  .clr:after {
    content: '';
    width: 100%;
    height: 0px;
    font-size: 0px;
    display: block;
    clear: both;
  }



  textarea {
    height: auto;
    vertical-align: top;
    margin: 30px 0px 25px;
    line-height: 26px;
    font-size: 16px;
    padding-left: 6px;
    outline: none;
    resize: none;
    border: 1px solid #888888;
    overflow: hidden;
    font-family: '微软雅黑';
  }

  a,
  a:focus {
    text-decoration: none;
    outline: none;
    blr: expression(this.onFocus=this.blur());
  }

  input,
  button,
  input:focus,
  button:focus,
  textarea:focus {
    outline: none;
    hide-focus: expression(this.hideFocus=true);
  }

  button::-moz-focus-inner,
  input[type='reset']::-moz-focus-inner,
  input[type='button']::-moz-focus-inner,
  input[type='submit']::-moz-focus-inner,
  input[type='file']>input[type='button']::-moz-focus-inner {
    border: none;
  }

  .over3 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  .over2 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .over {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }

  .disFlex {
    display: flex;
    align-items: center;
  }

  .disFlexs {
    display: flex;
    justify-content: space-around;
    flex-direction: column;
  }

  .tf-body {
    /* padding-top: calc(1.9rem + 1px); */
    padding-bottom: 45px;
  }




  .clearfix {
    zoom: 1
  }

  .clearfix::after {
    content: '\20';
    display: block;
    height: 0;
    clear: both;
  }

  @font-face {
    font-family: xqsl;
    src: url('../static/font/xqsl.ttf');
    /* IE9 */
  }


  .potion {
    position: absolute;
    left: 0;
    right: 0;
    top: 12.5rem;
    z-index: 556566565;
    margin: auto;
    width: 2.5rem;
    transform: translateX(0.2rem);
  }

  .imgback {
    position: absolute;
    left: 10px;
    top: 8px;
    z-index: 101;
    width: 1.5rem;
    z-index: 98;
  }

  .titName i {
    animation: fade 0.7s linear infinite alternate;
  }

  @keyframes fade {
    from {
      opacity: 0.8;
    }

    to {
      opacity: 0.2;
    }
  }



  #heng{
     display: none;
     justify-content: center;
     align-items: center;
     position: fixed;
     top: 0;
     left: 0;

     width: 100vw;
     height: 100vh;
     z-index: 999999999999999999999;
     background: rgba(0,0,0,0.85);

     img{
       width: 100%;
       height: 3rem;
       object-fit: cover;
     }
  }


  /deep/ .viewer-backdrop{ background-color: #FFFFFF !important;}
  /deep/ .viewer-footer{ display: none !important;}
  .viewer-backdrop{ background-color: #FFFFFF !important;}
  .viewer-footer{ display: none !important;}


</style>



// WEBPACK FOOTER //
// src/App.vue